import React from 'react'

export const AdvantagesCards = () => {
  const cards = [
    {id: 1, title: '3545', info: 'Самые популярные токены'},
    {id: 2, title: '1000% + APR', info: 'Ежедневные аирдропы'},
    {id: 3, title: '0 %', info: 'Сверхнизкие комиссии'},
    {id: 4, title: '№1 в отрасли', info: 'Всесторонняя ликвидность'},
  ]
  return (
    <div id="advantages-cards">
      <div className="container">
        <div className="advantages-cards">
          <div className="adv-cards">
            {
              cards.map(card => (
                <div className="adv-card" key={card.id}>
                  <span className='adv-card-txt'>{card.info}</span>
                  <h3 className='adv-card-title'>{card.title}</h3>
                  <div className="adv-card-line"></div>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </div>
  )
}
